function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Types from './types';

var Collection =
/*#__PURE__*/
function () {
  function Collection(_temp) {
    var _this = this;

    var _ref = _temp === void 0 ? this.constructor : _temp,
        name = _ref.name,
        _ref$shape = _ref.shape,
        _shape = _ref$shape === void 0 ? {} : _ref$shape,
        _ref$defaults = _ref.defaults,
        _defaults = _ref$defaults === void 0 ? {} : _ref$defaults,
        _ref$collection = _ref.collection,
        _collection = _ref$collection === void 0 ? {} : _ref$collection,
        _ref$firestore = _ref.firestore,
        firestore = _ref$firestore === void 0 ? _collection.firestore : _ref$firestore,
        _ref$id = _ref.id,
        _id = _ref$id === void 0 ? _collection.id : _ref$id;

    _defineProperty(this, "getCollection", function () {
      if (typeof _this.id === 'function') {
        return _this.collection.collection(_this.id());
      }

      return _this.collection;
    });

    _defineProperty(this, "validateShape", function (data, strict) {
      if (strict === void 0) {
        strict = true;
      }

      var rules = Object.keys(_this.shape);

      for (var i = 0; i < rules.length; i++) {
        var ruleKey = rules[i];
        var rule = _this.shape[ruleKey];
        var element = data[ruleKey];

        if (strict ? element === undefined || !rule(element) : element !== undefined && !rule(element)) {
          return {
            ok: false,
            data: element,
            error: "Failed type <" + rule._name_ + "> for <" + ruleKey + "> in <" + _this.name + ">. " + ("Received <" + element + "> with type <" + typeof element + ">.")
          };
        }
      }

      return {
        ok: true
      };
    });

    _defineProperty(this, "resolveShape", function (data, type, shape, defaults) {
      if (shape === void 0) {
        shape = _this.shape;
      }

      if (defaults === void 0) {
        defaults = _this.defaults;
      }

      var isRead = type === 'read';
      var isAdd = type === 'add';
      var isUpdate = type === 'update';
      var response = isRead ? _objectSpread({}, data) : {}; // Don't resolve to shape since derived props may exist

      if (!isRead) {
        // Resolve Shape
        Object.entries(shape).forEach(function (_ref2) {
          var shapeKey = _ref2[0],
              shapeMethod = _ref2[1];
          var item = data[shapeKey];

          if (item !== undefined || isAdd) {
            var mapShapeName = Types.map.shape._name_;
            var methodName = shapeMethod._name_,
                methodData = shapeMethod.data;
            var defaultValue = _this.defaults[shapeKey];

            var _defaults2 = typeof defaultValue === 'function' ? defaultValue(item) : defaultValue;

            switch (methodName) {
              case mapShapeName:
                response[shapeKey] = _this.resolveShape(item, type, methodData, _defaults2 || {});
                break;

              case Types.array.of._name_:
                if (methodData._name_ === mapShapeName) {
                  response[shapeKey] = item.map(function (data) {
                    return _this.resolveShape(data, type, methodData.data, {});
                  });
                } else {
                  response[shapeKey] = item;
                }

                break;

              case Types.oneOfType._name_:
                var _defaultValue = Types.object(_defaults2) ? _defaults2 : {};

                var firstPassedType = methodData.find(function (type) {
                  return type(_objectSpread({}, item, _defaultValue));
                });

                if (firstPassedType && firstPassedType._name_ === mapShapeName) {
                  response[shapeKey] = _this.resolveShape(item, type, firstPassedType.data, _defaultValue);
                } else {
                  response[shapeKey] = item;
                }

                break;

              default:
                response[shapeKey] = item;
                break;
            }
          }
        });
      }

      if (!isUpdate) {
        // Resolve Defaults
        Object.keys(defaults).forEach(function (defaultKey) {
          if (response[defaultKey] === undefined) {
            var defaultValue = defaults[defaultKey];
            response[defaultKey] = typeof defaultValue === 'function' ? defaultValue(data) : defaultValue;
          }
        });
      }

      return response;
    });

    _defineProperty(this, "handleQuery", function (queries) {
      var response = [];
      var queriesFlat = queries.flat(2);

      for (var i = 0, index = 0; i < queriesFlat.length; i++) {
        if (response[index] === undefined) {
          response[index] = [];
        }

        response[index].push(queriesFlat[i]);

        if ((i + 1) % 3 === 0) {
          index++;
        }
      }

      return response;
    });

    _defineProperty(this, "handleQueryExecute", function (queries) {
      if (Types.array(queries)) {
        var query = queries[0]; // Case 1

        if (Types.array(query) && query.length === 1) {
          var firstQuery = query[0];

          if (!Types.array(firstQuery)) {
            return firstQuery;
          }
        } // Case 2


        if (Types.array.of(function (prop) {
          return Types.array(prop) && prop.length === 1;
        })(queries)) {
          return queries.flat();
        }
      } // Case 3 and 4


      return queries;
    });

    _defineProperty(this, "handleRead", async function (doc) {
      if (doc.exists) {
        var data = await _this.resolveShape(doc.data(), 'read');

        var validation = _this.validateShape(data);

        if (validation.ok) {
          return _this.onRead(_objectSpread({}, data, {
            id: doc.id
          }));
        }

        throw _this.createError(validation);
      }
    });

    _defineProperty(this, "handleAction", async function (type, queries, onDoc, onRead, onWatch) {
      var isSingle = false;

      var collection = _this.getCollection();

      var queriesExec = _this.handleQueryExecute(queries);

      var isArray = Types.array(queriesExec);

      if (!isArray && queriesExec !== undefined) {
        isSingle = true;
        collection = Types.ref.any(queriesExec) ? queriesExec : _this.ref(queriesExec);
      } else if (isArray) {
        var query = queriesExec[0];

        if (!Types.array(query) && query !== undefined) {
          return Promise.all(queriesExec.map(function (query) {
            return _this.handleAction(type, query, onDoc, onRead, onWatch);
          }));
        } else {
          type = 'get';
          queriesExec.forEach(function (query) {
            var _collection2;

            collection = (_collection2 = collection).where.apply(_collection2, query);
          });
        }
      }

      if (type !== 'get') {
        return await onDoc(collection);
      }

      var onResponse = function onResponse(response) {
        if (response.docs ? response.empty : !response.exists) {
          if (isSingle) {
            return {};
          }

          return [];
        }

        var onDocRead = async function onDocRead(doc) {
          var data = await onDoc(doc);
          return onRead ? await onRead(data) : data;
        };

        if (response.docs) {
          if (isSingle) {
            response = response.docs[0];
          } else {
            return Promise.all(response.docs.map(onDocRead));
          }
        }

        return Promise.resolve(onDocRead(response));
      };

      if (onWatch) {
        return collection.onSnapshot(function (response) {
          return onResponse(response).then(onWatch);
        });
      }

      return collection.get().then(onResponse);
    });

    _defineProperty(this, "query", function () {
      for (var _len = arguments.length, queries = new Array(_len), _key = 0; _key < _len; _key++) {
        queries[_key] = arguments[_key];
      }

      var normalizedQueries = _this.handleQuery(queries);

      return {
        query: function query() {
          for (var _len2 = arguments.length, queries = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            queries[_key2] = arguments[_key2];
          }

          return _this.query.apply(_this, [normalizedQueries].concat(queries));
        },
        delete: function _delete() {
          return _this.delete(normalizedQueries);
        },
        get: function get(onRead) {
          return _this.get(normalizedQueries, onRead);
        },
        watch: function watch(onWatch, onRead) {
          return _this.watch(normalizedQueries, onWatch, onRead);
        },
        update: function update(data) {
          return _this.update(normalizedQueries, data);
        }
      };
    });

    _defineProperty(this, "get", function (queries, onRead) {
      return _this.handleAction('get', queries, _this.handleRead, onRead);
    });

    _defineProperty(this, "watch", function (queries, onWatch, onRead) {
      return _this.handleAction('get', queries, _this.handleRead, onRead, onWatch);
    });

    _defineProperty(this, "delete", function (queries) {
      return _this.handleAction('delete', queries, function (doc) {
        if (doc.ref) {
          return doc.ref.delete();
        } else {
          return doc.delete();
        }
      });
    });

    _defineProperty(this, "update", async function (queries, data) {
      var dataResolved = _this.resolveShape(data, 'update');

      var dataOnWrite = await _this.onWrite(dataResolved, data);
      var nextData = await _this.onUpdate(dataOnWrite, data);

      var validation = _this.validateShape(nextData, false);

      if (validation.ok) {
        return _this.handleAction('update', queries, async function (doc) {
          if (doc.ref) {
            await doc.ref.update(nextData);
          } else {
            await doc.update(nextData);
          }

          return _this.onRead(_objectSpread({}, data, nextData));
        });
      }

      throw _this.createError(validation);
    });

    _defineProperty(this, "add", async function (ref, data) {
      if (ref !== undefined && data === undefined) {
        data = ref;
        ref = _this.ref();
      }

      if (Types.string(ref)) {
        ref = _this.ref(ref);
      }

      if (Types.array(data)) {
        return Promise.all(data.map(function (item) {
          return _this.add(item);
        }));
      }

      var dataResolved = _this.resolveShape(data, 'add');

      var dataWithId = _objectSpread({}, dataResolved, {
        id: ref.id
      });

      var dataOnWrite = await _this.onWrite(dataWithId, data);
      var dataOnAdd = await _this.onAdd(dataOnWrite, data);

      var validation = _this.validateShape(dataOnAdd);

      if (validation.ok) {
        var id = dataOnAdd.id,
            dataToAdd = _objectWithoutPropertiesLoose(dataOnAdd, ["id"]);

        await ref.set(dataToAdd);
        return _this.onRead(_objectSpread({}, data, dataOnAdd));
      }

      throw _this.createError(validation);
    });

    _defineProperty(this, "ref", function (id) {
      return id !== undefined ? _this.getCollection().doc(id) : _this.getCollection().doc();
    });

    _defineProperty(this, "id", function () {
      return _this.ref().id;
    });

    _defineProperty(this, "geopoint", function (_ref3) {
      var lat = _ref3.lat,
          long = _ref3.long;
      return new Collection.GeoPoint(lat, long);
    });

    _defineProperty(this, "timestamp", function (date) {
      return new Collection.Timestamp(date);
    });

    this.id = _id;
    this.name = name;
    this.shape = _shape;
    this.defaults = _defaults;
    this.collection = _collection.id ? _collection : typeof _id === 'string' ? firestore.collection(_id) : firestore;

    if (!Collection.firestore) {
      Collection.firestore = firestore;
    }

    if (!Collection.DocumentReference) {
      Collection.DocumentReference = firestore.app.firebase_.firestore.DocumentReference;
    }

    if (!Collection.Timestamp) {
      Collection.Timestamp = firestore.app.firebase_.firestore.Timestamp;
    }

    if (!Collection.GeoPoint) {
      Collection.GeoPoint = firestore.app.firebase_.firestore.GeoPoint;
    }

    if (!Object.keys(this.shape).length) {
      this.validateShape = function () {
        return {
          ok: true
        };
      };

      this.resolveShape = function (data) {
        return data;
      };
    }
  }
  /**
  | ------------------
  | Private API
  | ------------------
  */


  var _proto = Collection.prototype;

  _proto.createError = function createError(validation) {
    var error = new Error(validation.error);
    error.data = validation.data;
    return error;
  }
  /**
  | ------------------
  | Handlers
  | ------------------
  */
  ;

  /**
  | ------------------
  | Listeners
  | ------------------
  */
  _proto.onRead = function onRead(data) {
    return data;
  };

  _proto.onAdd = function onAdd(data) {
    return data;
  };

  _proto.onUpdate = function onUpdate(data) {
    return data;
  };

  _proto.onWrite = function onWrite(data) {
    return data;
  };

  return Collection;
}();

export { Collection as default };